import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { useContext, useState } from 'react';
import CheckoutForm from './CheckoutForm';
import { GlobalContext } from '../../context/globalState';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY, {
  applePayMethod: {
    displayName: 'Print Your Friends',
    countryCode: 'FR',
  }
});

function PaymentComponent(props) {
  const {disabled, onSuccess, onError, onProcessing} = props;
  const { info_events:{ id, prix_par_impression, devise } , quantity } = useContext(GlobalContext);
  const [clientSecret, setClientSecret] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const createPaymentIntent = async (eventId, quantity) => {
    setLoading(true);
    setError('');
    
    try {
      const response = await fetch(process.env.REACT_APP_REST_API_LOCATION + '/../payment/create-payment-intent', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          eventId,
          quantity,
        }),
      });

      if (!response.ok) {
        throw new Error('Erreur réseau');
      }

      const data = await response.json();
      
      if (data.error) {
        throw new Error(data.error);
      }

      setClientSecret(data.client_secret);
      onProcessing(true)
      
    } catch (err) {
      setError(err.message);
      console.error('Erreur création PaymentIntent:', err);
    } finally {
      setLoading(false);
    }
  };

  const options = {
    clientSecret,
    appearance: {
      theme: 'stripe',
      variables: {
        colorPrimary: '#31a9a4',
      },
    },
    wallets: {
      applePay: 'auto',
      googlePay: 'auto',
      paypal: 'auto',
    },
  };

  return (
    <div>
    {!clientSecret ? (
      <div>
        <button 
          className="btn btn-pink"
          onClick={() => createPaymentIntent(id, quantity)}
          disabled={loading || disabled} 
        >
          {loading ? 'Chargement...' : `Lancer l'impression pour ${prix_par_impression * quantity}${devise === 'EUR' ? '€' : ' ' + devise}`}
        </button>
        {error && <div className="error">{error}</div>}
      </div>
    ) : (
      <Elements options={options} stripe={stripePromise}>
        <CheckoutForm onClose={() => {
          setClientSecret('')
          onProcessing(false)
          }}  onSuccess={onSuccess}/>
      </Elements>
    )}
  </div>
  );
}

export default PaymentComponent;